import { render, staticRenderFns } from "./KisPersonFilter.vue?vue&type=template&id=6fa79e6a"
import script from "./KisPersonFilter.js?vue&type=script&lang=js&external"
export * from "./KisPersonFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports